/**
 * This is a utilities file for the autocomplete component.
 * Part of the reason it exists is to be able to stub out
 * some things that don't work with jsdom.
 */
export { selectRangeOfText, selectAllText, moveCursorToTheEnd }

/**
 * This will take a node and select the given range of text from start to end in a
 * way that works for iOS
 * @param  {HTMLInputElement} node - the input to select the text in
 * @param  {Number} start - the index to start the selection
 * @param  {Number} end - the index to end the selection
 */
function selectRangeOfText(node, start, end) {
  // select all the text, but do it on the next tick because iOS has issues otherwise
  setTimeout(() => {
    // we're using setSelectionRange rather than select because select doesn't work with iOS
    //  setSelectionRange method apply only to inputs of types text, search, URL, tel and password
    // This check was added to avoid the console errors as setSelectionRange was used on input type email
    if (node.type !== 'email') {
      node.setSelectionRange(start, end)
    }
  })
}

/**
 * This will take a node and select all the text in it in a way that works for iOS
 * @param {HTMLInputElement} node - the input to select the text in
 */
function selectAllText(node) {
  selectRangeOfText(node, 0, node.value.length)
}

/**
 * This moves the cursor position to the end of the text in the input node in a way
 * that works on iOS
 * @param {HTMLInputElement} node - the input to set the cursor position in
 */
function moveCursorToTheEnd(node) {
  const { length } = node.value
  node.setSelectionRange(length, length)
}
